import request from '@/utils/request'

export function getProducts(query) {
  return request({
    url: '/home/api/producePage',
    method: 'POST',
    params:query
  })
}